/*
 * @Author: your name
 * @Date: 2020-06-16 17:14:20
 * @LastEditTime: 2020-06-16 17:14:20
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /esr-mobile/src/modules/front/common/bus.js
 */

import Vue from 'vue'
export default new Vue()
